<template>
  <div>
    <pdl-tabs :value="defaultTab">
      <pdl-tab-pane :name="defaultTab">
        <span slot="label" qaid="notification-settings-grid-stockwatch-bike-label">
          {{ tabNames.find((item) => item.name === 'bikesStockWatch').translation }}
        </span>
        <notification-settings-stockwatch-grid
          :items="stockWatchBikeData.stockwatches || []"
          :no-item="bikesStockWatchNoItemMessage"
          qaid="notification-settings-grid-stockwatch-bike"
          @update-data-list="fetchStockWatchBikeData"
        />
      </pdl-tab-pane>
      <pdl-tab-pane>
        <span slot="label" qaid="notification-settings-grid-stockwatch-am-label">
          {{ tabNames.find((item) => item.name === 'accessoriesStockWatch').translation }}
        </span>
        <notification-settings-stockwatch-grid
          :items="stockWatchAftermarketData.stockwatches || []"
          :no-item="partsStockWatchNoItemMessage"
          qaid="notification-settings-grid-stockwatch-am"
          @update-data-list="fetchStockWatchAftermarketData"
        />
      </pdl-tab-pane>
      <pdl-tab-pane>
        <span slot="label" qaid="notification-settings-grid-eta-bike-label">
          {{ tabNames.find((item) => item.name === 'bikesEta').translation }}
        </span>
        <notification-settings-eta-grid
          :items="EtaBikeData.orderLines || []"
          :token="token"
          :no-item="bikesEtaNoItemMessage"
          qaid="notification-settings-grid-eta-bike"
          @update-data-list="fetchEtaBikeData"
        />
      </pdl-tab-pane>
      <pdl-tab-pane>
        <span slot="label" qaid="notification-settings-grid-eta-am-label">
          {{ tabNames.find((item) => item.name === 'accessoriesEta').translation }}
        </span>
        <notification-settings-eta-grid
          :items="EtaAftermarketData.orderLines || []"
          :token="token"
          :no-item="partsEtaNoItemMessage"
          qaid="notification-settings-grid-eta-am"
          @update-data-list="fetchEtaAftermarketData"
        />
      </pdl-tab-pane>
      <pdl-tab-pane>
        <span slot="label" qaid="notification-settings-grid-prefs-label">
          {{ tabNames.find((item) => item.name === 'emailPrefs').translation }}
        </span>
        <notification-settings-email-preferences :columns="emailPrefColumns" :groupings="notificationPrefsData" />
      </pdl-tab-pane>
    </pdl-tabs>
  </div>
</template>

<script>
import axios from 'axios';
import Vue from 'vue';
import {PdlTabs, PdlTabPane} from '@pedal/pdl-tabs';
import NotificationSettingsEtaGrid from '@/components/containers/my-account/NotificationSettingsEtaGrid';
import NotificationSettingsStockwatchGrid from '@/components/containers/my-account/NotificationSettingsStockwatchGrid';
import NotificationSettingsEmailPreferences from '@/components/containers/notifications/NotificationSettingsEmailPreferences';

export default {
  components: {
    PdlTabs,
    PdlTabPane,
    NotificationSettingsEtaGrid,
    NotificationSettingsStockwatchGrid,
    NotificationSettingsEmailPreferences,
  },
  props: {
    token: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      stockWatchBikeData: [],
      stockWatchAftermarketData: [],
      EtaBikeData: [],
      EtaAftermarketData: [],
      notificationPrefsData: [],
      noItemDefaultMessage: 'Sorry, you have no watched items to display',
      bikesEtaNoItemMessage: '',
      partsEtaNoItemMessage: '',
      bikesStockWatchNoItemMessage: '',
      partsStockWatchNoItemMessage: '',
    };
  },
  computed: {
    emailPrefColumns() {
      return [
        {label: this.$t('text.event')},
        {
          label: this.$t('text.online'),
          cssClasses: 'text-right',
        },
        {
          label: this.$t('address.email'),
          cssClasses: 'text-right',
        },
      ];
    },

    defaultTab() {
      return this.tabNames[0].translation;
    },

    tabNames() {
      // Use computed to make BP translation reactive in pdl-tab-pane
      return [
        {
          name: 'bikesStockWatch',
          translation: this.$t('notifications.B2B.bikes.stockWatch'),
        },
        {
          name: 'accessoriesStockWatch',
          translation: this.$t('notifications.B2B.accessories.stockWatch'),
        },
        {
          name: 'bikesEta',
          translation: this.$t('notifications.B2B.bikes.eta'),
        },
        {
          name: 'accessoriesEta',
          translation: this.$t('notifications.B2B.accessories.eta'),
        },
        {
          name: 'emailPrefs',
          translation: this.$t('notifications.B2B.emailPreferences'),
        },
      ];
    },
  },
  mounted() {
    this.fetchStockWatchBikeData();
    this.fetchStockWatchAftermarketData();
    this.fetchEtaBikeData();
    this.fetchEtaAftermarketData();
    this.fetchNotificationPrefsEmailData();
  },
  methods: {
    /* Should probably put these fetchers in a loop */
    fetchStockWatchBikeData() {
      return axios
        .get('/notification-settings/stock-watch?producttype=bike')
        .then(({data: {data, meta}}) => {
          if (data) {
            data?.stockwatches.forEach((element) => {
              Vue.set(element, 'active', false);
            });
            this.stockWatchBikeData = data;
            this.bikesStockWatchNoItemMessage =
              meta.feedback.message && meta.feedback.message != null
                ? meta.feedback.message.basePropertyValue
                : this.noItemDefaultMessage;
          } else if (data === null && meta != null) {
            this.bikesStockWatchNoItemMessage = meta.feedback.message.basePropertyValue;
          }
        })
        .catch((error) => console.error(error));
    },
    fetchStockWatchAftermarketData() {
      return axios
        .get('/notification-settings/stock-watch?producttype=am')
        .then(({data: {data, meta}}) => {
          if (data) {
            data?.stockwatches.forEach((element) => {
              Vue.set(element, 'active', false);
            });
            this.stockWatchAftermarketData = data;
            this.partsStockWatchNoItemMessage =
              meta.feedback.message && meta.feedback.message != null
                ? meta.feedback.message.basePropertyValue
                : this.noItemDefaultMessage;
          } else if (data === null && meta != null) {
            this.partsStockWatchNoItemMessage = meta.feedback.message.basePropertyValue;
          }
        })
        .catch((error) => console.error(error));
    },
    fetchEtaBikeData() {
      return axios
        .get('/notification-settings/eta-watch?producttype=bike')
        .then(({data: {data, meta}}) => {
          if (data.orderLines) {
            data.orderLines.forEach((element) => {
              Vue.set(element, 'checkboxActive', false);
              Vue.set(element, 'etaWatch', true);
            });
          }
          this.bikesEtaNoItemMessage =
            meta.feedback.message && meta.feedback.message != null
              ? meta.feedback.message.basePropertyValue
              : this.noItemDefaultMessage;
          this.EtaBikeData = data;
        })
        .catch((error) => console.error(error));
    },
    fetchEtaAftermarketData() {
      return axios.get('/notification-settings/eta-watch?producttype=am').then(({data: {data, meta}}) => {
        if (data.orderLines) {
          data.orderLines.forEach((element) => {
            Vue.set(element, 'checkboxActive', false);
            Vue.set(element, 'etaWatch', true);
          });
        }
        this.partsEtaNoItemMessage =
          meta.feedback.message && meta.feedback.message != null
            ? meta.feedback.message.basePropertyValue
            : this.noItemDefaultMessage;
        this.EtaAftermarketData = data;
      });
    },
    fetchNotificationPrefsEmailData() {
      return axios.get('notification-settings/user-preferences/').then(({data: {data}}) => {
        if (data) {
          this.notificationPrefsData = data;
        }
      });
    },
  },
};
</script>
